import React from 'react';
import PropTypes from 'prop-types';
import {Tabs} from '@learningblocks/storybook-components';
import {Description} from './Description';
import {Title} from './Title';
import './style.scss';

const TAB = {
  STEPS: 'STEPS',
  TECHNIQUES: 'TECHNIQUES',
};
/**
 * ViewTabPane:
 *  - TabPane displayed on content-area of TabPane.
 *    The pane display a title and description of the view or design-view in general
 *    User can select a tab to more between different view
 */
export function ViewTabPane(props) {
  const onTabClicked = (tab) => props.onTabSelect(tab);
  React.useEffect(()=>{
    const element = document.querySelector('.' + 'toggleTabView_menuList');
    if (element) {element.scrollIntoView({block: "start"});}
    
  },[props.current])

  const className = `toggleTabView ${props.className}`;

  return (
    <Tabs.Tabs className={className} default={props.current}>
      <Tabs.List className='toggleTabView_menuList'>
        <Tabs.Menu
          tabIndex={props.tabIndex}
          className='toggleTabView_menuList--menu'
          onClick={onTabClicked}
          value={TAB.STEPS}
          key='0'>
          Steps
        </Tabs.Menu>
        <Tabs.Menu
          tabIndex={props.tabIndex}
          className='toggleTabView_menuList--menu'
          onClick={onTabClicked}
          value={TAB.TECHNIQUES}
          key='1'>
          Techniques
        </Tabs.Menu>
      </Tabs.List>
      <Tabs.Panel
        key='0'
        menuValue={TAB.STEPS}
        className='toggleTabView_tabContent'>
        <Title text={props.title} />
        <Description content={props.description} />
      </Tabs.Panel>
      <Tabs.Panel
        key='1'
        menuValue={TAB.TECHNIQUES}
        className='toggleTabView_tabContent'>
        <Title text={props.title} />
        <Description content={props.description} />
      </Tabs.Panel>
    </Tabs.Tabs>
  );
}

ViewTabPane.propTypes = {
  /**
   * Titile of the Toggle tab component
   */
  title: PropTypes.string.isRequired,
  /**
   * Description array which may contain more than one paragraph of content to display in ViewTabPane
   */
  description: PropTypes.arrayOf(PropTypes.string).isRequired,
  /**
   * style to recive from out of the component
   */
  className: PropTypes.string,
  /**
   * is it StepsView or TechniquesView that is displayed below is set using currentView
   */
  current: PropTypes.oneOf(['STEPS', 'TECHNIQUES']).isRequired,
  /**
   * Function to invoke when a Tab is Selected
   */
  onTabSelect: PropTypes.func.isRequired,
  /**
   * for keyboard navigation
   */
  tabIndex: PropTypes.number,
};

ViewTabPane.defaultProps = {
  title: '',
  description: '',
};
